import { Event, Market } from "../../contracts";

export const setSportId = (sportIds: string[], item: Event | Market): string => {
    return sportIds.indexOf(item.sportId) !== -1
        ? item.sportId
        : "0";
}